/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgEventRow } from "../models/OrgEventRow";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class OrgEventsService {
  /**
   * Get Org Events
   * The bell's list for this admin: the organization's events of the last
   * 30 days, read or not, and older ones still unread, at most 50, newest
   * first (a form filled out, a payment method added, a charge failed, a
   * tutor's payroll bank added, a meeting request, a tutor's answer to one),
   * each read or unread for them. Marked through POST /messages/read_state.
   * @returns OrgEventRow Successful Response
   * @throws ApiError
   */
  public static getOrgEvents({
    orgId,
  }: {
    orgId: number;
  }): CancelablePromise<Array<OrgEventRow>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/org_events",
      query: {
        org_id: orgId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
